import { useMemo } from "react";
import { Endpoints, queryKeys } from "../api";
import { useAuth } from "../contexts";
import { getRequestOptions } from "../helper-functions";
import { useAxios, useGenericQuery } from "../hooks";
import { IUseQueryPaged, PagedResponse, QueryHookParams, QueryType, TissueOfferStatus } from "../models";

interface IUseTissueOfferStatusQuery extends Pick<IUseQueryPaged<TissueOfferStatus>, "listQuery"> {}

export const useTissueOfferStatusQuery = (params?: QueryHookParams): IUseTissueOfferStatusQuery => {
    const { isAuthorized } = useAuth();
    const { get } = useAxios();
    const url = Endpoints.TissueOfferStatus;
    const queryType = params?.queryType ?? QueryType.List;

    const listQuery = useGenericQuery({
        queryFn: (config) =>
            get<PagedResponse<TissueOfferStatus>>(
                getRequestOptions(url, config, undefined, undefined, undefined, false, true)
            ).then((response) => response.items),
        queryKey: queryKeys.tissueOfferStatuses.lists(),
        placeholderData: [],
        enabled: isAuthorized && queryType === QueryType.List,
    });

    return useMemo(() => ({ listQuery }), [listQuery]);
};
